module.exports = __webpack_public_path__ + "img/message-circle.986b31d2.svg";